module.exports = __webpack_public_path__ + "img/jqr_zy.2394da35.png";